@let loading = loadingSg();
<div class="atn-space-modal-functionalizations">
  @if (loading) {
    <div class="atn-space-modal-functionalizations__loader">
      <atn-ds-loader />
    </div>
  } @else {
    @let displayFunctionalizations = displayFunctionalizationsSg();
    @let readonly = readonlySg();
    @for (func of displayFunctionalizations; track func.functionId) {
      <div
        class="atn-space-modal-functionalizations__row"
        [class.atn-space-modal-functionalizations__row--readonly]="readonly"
      >
        <span class="atn-space-modal-functionalizations__label">
          {{ func.name }}
        </span>

        <mat-slider
          min="0"
          max="100"
          step="5"
          showTickMarks
          discrete
          [disabled]="readonly"
          [displayWith]="formatLabel"
        >
          <input
            matSliderThumb
            type="range"
            [value]="func.percent * 100"
            (change)="!readonly && handleSliderChange(func.functionId, $event)"
          />
        </mat-slider>

        @if (readonly) {
          <span class="atn-space-modal-functionalizations__percent">
            {{ func.percent | percent: '1.0-2' }}
          </span>
        } @else {
          <atn-ds-number
            [type]="IntrinsicValueType.Percent"
            [config]="{ min: 0, max: 100 }"
            [value]="func.percent"
            (change)="handleInputChange(func.functionId, $event)"
          />
        }
      </div>
    }

    @let isEmpty = isEmptySg();
    @let isFullyCoded = isFullyCodedSg();

    @if (!isEmpty && !isFullyCoded) {
      @let total = totalFunctionalUsageSg();
      @let percent = total | percent: '1.0-2';
      @let description =
        total > 1
          ? 'Total functional usage exceeds 100% (' + percent + ')'
          : 'Total functional usage is below 100% (' + percent + ')';

      <div class="atn-space-modal-functionalizations__warning">
        <atn-ds-notice
          [style]="StyleEnum.Warning"
          [description]="description"
        />
      </div>
    }
  }
</div>
